var character = "Characters";
var copied = "Copied";
var copy = "Copy";
var insert = "Insert";
var loading = "加載中";
var orCopyLink = "Or copy link";
var submit = "Submit";
var zhTranslations = {
	"actionPopover.delete": "刪除",
	"actionPopover.deleteNotification": "刪除這則通知",
	"actionPopover.edit": "編輯",
	"actionPopover.inviteShareCommunity": "邀請或分享討論區",
	"actionPopover.joinCommunity": "加入討論區",
	"actionPopover.leaveCommunit": "離開討論區",
	"actionPopover.leaveCommunity": "離開討論區",
	"actionPopover.leaveCommunity.accept": "離開",
	"actionPopover.leaveCommunity.cancel": "取消",
	"actionPopover.leaveCommunity.description": "您確定要離開討論區",
	"actionPopover.leaveCommunity.title": "離開討論區",
	"actionPopover.report": "回報問題",
	"actionPopover.turnOffNotification": "關閉通知",
	"actionPopover.turnOffNotificationAbout": "關閉［］的通知",
	"actionPopover.turnOnNotification": "開啟通知",
	"adBanner.title": "advertisement",
	"admin.comments": "留言",
	"admin.communities": "討論區",
	"admin.community": "討論區",
	"article.shareOn": "分享至",
	"articleAuthor.title.expert": "Expertly reviewed by",
	"articleAuthor.title.fact-check": "資料查核：{name}",
	"articleAuthor.title.medical": "Medically reviewed by",
	"articleAuthor.title.written-by": "Written by",
	"articlePage.articleReviewerBy": "醫學審稿： {name}",
	"articlePage.readMore": "讀更多",
	"articlePage.showLess": "顯示較少",
	"babyGrowth.alert.bmi": "在世界衛生組織公布的0至5歲資料範圍中，沒有{name}的BMI測量值可顯示。請使用5歲以上的 <a>BMI身體質量指數計算機</a>計算。",
	"babyGrowth.alert.head": "在世界衛生組織公布的0至5歲資料範圍中，沒有{name}的頭圍測量值可顯示。\n",
	"babyGrowth.alert.weight": "在世界衛生組織公布的0至10歲資料範圍中，沒有{name}的體重測量值可顯示。\n\n\n ",
	"babyGrowth.babyInfo": "寶寶資訊",
	"babyGrowth.chartTitle": "世界衛生組織 - {name} 生長曲線",
	"babyGrowth.chartTitle.noName": "您寶貝的兒童生長曲線",
	"babyGrowth.cm": "公分",
	"babyGrowth.drawer.addMeasurement": "新增測量值",
	"babyGrowth.drawer.createBaby": "新建小孩基本資料",
	"babyGrowth.drawer.switchProfile": "切換基本資料",
	"babyGrowth.emptyName": "您的寶貝",
	"babyGrowth.error.atLeastOneOf": "在以下項目中至少包含一項：體重、身高、頭圍（頭部）",
	"babyGrowth.error.birthdayRequired": "生日必填",
	"babyGrowth.error.invalidAge": "測量值超過年齡範圍",
	"babyGrowth.error.invalidMeasurementDate": "測量日期無效",
	"babyGrowth.error.invalidValue": "請輸入有效數值",
	"babyGrowth.error.measurementDateLowerThanBirthday": "輸入日期早於您小孩的生日",
	"babyGrowth.error.outOfRange": "測量值超過世界衛生組織數值範圍",
	"babyGrowth.error.title": "資料有誤",
	"babyGrowth.head": "頭部",
	"babyGrowth.headCircumference": "頭圍",
	"babyGrowth.height": "身高",
	"babyGrowth.input.babyName": "您孩子的名字",
	"babyGrowth.input.birthday": "小孩生日",
	"babyGrowth.input.bmi": "身體質量",
	"babyGrowth.input.bodyMass": "身體質量指數 BMI",
	"babyGrowth.input.checkSubmit": "追蹤您孩子的成長",
	"babyGrowth.input.measurementDate": "量測日期",
	"babyGrowth.input.submit": "追蹤您小孩的成長情況",
	"babyGrowth.kg": "公斤",
	"babyGrowth.kg.m2": "公斤/平方公尺",
	"babyGrowth.monthly": "每月",
	"babyGrowth.nickname": "或暱稱",
	"babyGrowth.optional": "選填",
	"babyGrowth.pageTitle": "您的小孩成長結果",
	"babyGrowth.percentiles": "百分位數",
	"babyGrowth.placeholder.babyName": "新增小孩姓名",
	"babyGrowth.popup.heading": "Baby's Profile",
	"babyGrowth.reCalculate": "重新計算",
	"babyGrowth.record": "紀錄",
	"babyGrowth.save": "檢視兒童成長曲線圖",
	"babyGrowth.save.loggedIn": "看看（您寶貝姓名）的兒童生長曲線",
	"babyGrowth.weekly": "每周",
	"babyGrowth.weight": "體重",
	"babyGrowth.xLabel": "年齡({recurrence})",
	"babyGrowth.yearly": "每年",
	"babyPoop.findOut": "了解詳情",
	"babyPoopTool.name": "嬰兒糞便",
	"babyVaccine.banner.readmore": "觀看更多",
	"babyVaccine.detail.benifit": "益處",
	"babyVaccine.detail.contraindication": "禁忌",
	"babyVaccine.detail.definition": "定義",
	"babyVaccine.detail.relatedArticles": "相關文章",
	"babyVaccine.immunization.vaccineName": "疫苗名稱",
	"babyVaccine.immunization.warning": "接種紀錄表能夠提醒您那些疫苗已經施打、即將要施打以及漏打的疫苗",
	"babyVaccine.popup.button": "Create a new profile",
	"babyVaccine.popup.button.submit": "儲存",
	"babyVaccine.popup.checkbox.suggestedDate": "建議接種日期(可調整)",
	"babyVaccine.popup.confirm.close": "更改日期",
	"babyVaccine.popup.confirm.description": "您的寶貝已在{date} 接種此疫苗",
	"babyVaccine.popup.confirm.ok": "確認",
	"babyVaccine.popup.confirm.title": "施打疫苗日期",
	"babyVaccine.popup.input.suggestedDate": "不記得/ 設定為建議日期",
	"babyVaccine.popup.label.doses": "劑次",
	"babyVaccine.popup.tab.benefits": "接種效果",
	"babyVaccine.popup.tab.contraindication": "禁忌症",
	"babyVaccine.popup.tab.detail": "疫苗介紹",
	"babyVaccine.popup.tab.schedule": "追蹤",
	"babyVaccine.popup.title": "疫苗資訊",
	"babyVaccine.status.all": "全部",
	"babyVaccine.status.missed": "未接種",
	"babyVaccine.status.next": "下一劑",
	"babyVaccine.status.upcoming": "待接種",
	"babyVaccine.status.vaccinated": "已施打疫苗",
	"babyVaccine.timeline.antigen": "抗原:",
	"babyVaccine.timeline.atBirth": "剛出生",
	"babyVaccine.timeline.total": "總計： {number} 劑",
	"babyVaccine.timeline.totalNext": "下一次{number} 劑次(s)",
	"babyVaccine.timeline.totalPast": "過去 {number} 劑次(s)",
	"babyVaccine.vaccineCard.injected": "已接種",
	"babyVaccine.vaccineCard.markAsInjected": "標記為已接種",
	"babyVaccine.vaccineInfo.dose": "劑次: {ordinal}/{total}",
	"babyVaccine.vaccineInfo.injectedDate": "接種日期: {date}",
	"babyVaccine.vaccineInfo.mandatory": "公費",
	"babyVaccine.vaccineInfo.optional": "自費",
	"babyVaccine.vaccineInfo.suggested": "建議接種日期: {date}",
	"babyVaccineTool.heading": "疫苗接種小幫手：查詢、記錄並提醒孩子的預防接種時程",
	"bmi.ageInput": "你的年齡？",
	"bmi.ageInput.desc": "（歲）",
	"bmi.ageInput.error": "請輸入合理的數值",
	"bmi.heading": "BMI 計算器：計算 BMI 指數、評估體重是否標準",
	"bmi.heightInput": "你的身高？",
	"bmi.heightInput.desc": "（公分）",
	"bmi.heightInput.error": "請輸入合理的身高範圍",
	"bmi.objective": "目標",
	"bmi.objective.gainWeight": "增加肌肉",
	"bmi.objective.loseWeight": "減少體脂肪",
	"bmi.objective.maintainWeight": "維持體重",
	"bmi.result.healthy": "體重正常",
	"bmi.result.overweight": "過重",
	"bmi.result.underweight": "體重過輕",
	"bmi.selectGender": "你的性別",
	"bmi.submit": "計算",
	"bmi.weightInput": "你的體重",
	"bmi.weightInput.desc": "（公斤）",
	"bmi.weightInput.error": "請輸入合理的體重範圍",
	"bmr.heading": "BMR / TDEE 計算器：計算基礎代謝率、每日消耗總熱量",
	"booking.searchBar.allLocations": "全部地點",
	"booking.searchBar.allSpecialties": "全部特色",
	"booking.searchBar.currentLocation": "現在位置",
	"booking.searchBar.grantLocation": "授予您的位置權限",
	"booking.searchBar.locationPlaceholder": "選擇城市",
	"booking.searchBar.noResults": "無結果",
	"booking.searchBar.placeholder.doctor": "使用醫師名稱搜尋",
	"booking.searchBar.placeholder.hospital": "使用醫院名稱搜尋",
	"booking.searchBar.placeholder.service": "使用服務項目搜尋",
	"booking.searchBar.placeholder.specialty": "使用專業服務搜尋",
	"booking.searchBar.popularKey": "熱門關鍵字",
	"booking.searchBar.searchButton": "搜尋",
	"booking.searchBar.searchInput.placeholder": "搜尋醫師姓名",
	"booking.searchBar.useCurrentLocation": "使用我現在的位置",
	"booking.searchBar.viewAll": "查看全部",
	"booking.searchPopup.doctors": "醫師",
	"booking.searchPopup.hospitals": "醫院及診所",
	"booking.searchPopup.searchIn.doctors": "Search \"{name}\" in Doctors",
	"booking.searchPopup.searchIn.hospitals": "Search \"{name}\" in Hospitals",
	"booking.searchPopup.searchIn.services": "See \"{name}\" in Services",
	"booking.searchPopup.searchIn.specialties": "Search \"{name}\" in Specialties",
	"booking.searchPopup.seeAll": "See All",
	"booking.searchPopup.seeLessSpecialties": "See less specialties",
	"booking.searchPopup.seeMoreSpecialties": "See more specialties",
	"booking.searchPopup.services": "Services",
	"booking.searchPopup.specialties": "Specialties",
	"booking.searchResult.description": "{search_type} 在 {search_location}",
	"bottomBar.share": "Share",
	"cardAuthor.admin": "Admin",
	"cardAuthor.ambassador": "Ambassador",
	"cardAuthor.expert": "Expert",
	"cardAuthor.guide": "Guide",
	"cardAuthor.influencer": "Influencer",
	"cardAuthor.localAdmin": "Local Admin",
	"cardAuthor.moderator": "Moderator",
	"cardAuthor.sponsor": "Sponsor",
	"cardPost.anonymous": "Anonymous",
	"cardPost.option.anonymous": "照片",
	"cardPost.public": "匿名",
	"cardReactions.comment": "Comment",
	"cardReactions.like": "Like",
	"cardReactions.repliesCount": "{count} 回覆",
	"cardReactions.reply": "Reply",
	"cardReactions.save": "Save",
	"cardReactions.unSave": "Unsave",
	"cardReply.disclaimer": "<strong>Disclaimer:</strong> The content is furnished relying on authenticated information sources.",
	"cardReply.endorse": "Endorse",
	"cardReply.opposePopup.content": "Can you please provide the reasons for refuting this answer?",
	"cardReply.opposePopup.submit": "Submit",
	"cardReply.pppose": "Refute",
	"cardReply.recommentCategories.heading": "Related content",
	"cardReply.source": "Sources",
	"cardReply.verifyBy": "Medically reviewed by {name}",
	"careBooking.bookAnAppointment": "預約時段",
	"categoryPage.info.reviewed": "醫學審稿：",
	"categoryPage.onDate": "{date}",
	character: character,
	"chatbot.with.me": "Chat with me",
	"childCard.age.months": "{month} 個月大",
	"childCard.age.oneMonth": "一個月",
	"childCard.age.oneWeek": "一週",
	"childCard.age.oneYear": "一年",
	"childCard.age.oneYearMonth": "1 歲 {month} 個月",
	"childCard.age.oneYearOneMonth": "1 歲 1 個月",
	"childCard.age.week": "{weeks} 週",
	"childCard.age.yearMonth": "{year} 年 {month} 月",
	"childCard.age.yearNoMonth": "{year} 年",
	"childCard.age.yearOneMonth": "{year} 歲 1 個月",
	"childCard.boy": "男生",
	"childCard.girl": "女生",
	"childCard.menu.add": "新增小孩基本資料",
	"childCard.menu.edit": "編輯 {name}基本資料",
	"childCard.menu.remove": "移除 {name}基本資料",
	"childCard.menu.switch": "切換小孩資料",
	"childCard.noName": "小孩名字",
	"choicePopover.ambassadorPosts": "Ambassador posts",
	"choicePopover.expertPosts": "Expert posts",
	"choicePopover.lastestPost": "Latest posts",
	"choicePopover.latest": "Latest",
	"choicePopover.newest": "Newest",
	"choicePopover.oldest": "Oldest",
	"choicePopover.popular": "Popular",
	"choicePopover.popularPost": "Popular posts",
	"choicePopover.sort": "Sort",
	"choose.community": "Choose your community",
	"choose.other.community": "Choose another community",
	"chooseBaby.button": "查看您的兒童生長曲線圖",
	"chooseBaby.new": "或新增小孩基本資料",
	"chooseBaby.placeholder": "請提供小孩名字",
	"chooseBaby.title": "選擇小孩基本資料",
	"comment.count": "{count} comments",
	"comment.now": "Comment now",
	"comment.seeMoreComments": "See {count} more comments",
	"comment.seeMoreReplies": "See {count} more replies",
	"commentPopup.warning.newPost": "Your question will be public",
	"common.playing": "正在播放...",
	"common.profileNavigator.newsletterSubscription": "Newsletter Subscription",
	"common.sponsoredBy": "HELLO 醫師 x",
	"common.totalView": "{number} 次瀏覽",
	"community.choose": "Choose a community",
	"community.notification.joined": "You joined {name} community",
	"community.notification.left": "You left {name} community",
	copied: copied,
	copy: copy,
	"createPost.askDoctor": "詢問醫師",
	"createPost.askDoctor.description": "上傳帖子時最多允許上傳 10 張圖片",
	"createPost.askDoctorChoice.no": "No",
	"createPost.askDoctorChoice.yes": "Yes",
	"createPost.communityAndTopic": "視頻或連結",
	"createPost.message.askDoctorRequire": "Would you like to ask a question to our doctor?",
	"createPost.message.askDoctorRequireMess": "僅允許來自 Youtube、Facebook 和 Tiktok 的資源",
	"createPost.message.lengthDescription": "請選擇一個選項",
	"createPost.message.lengthTitle": "The title must be at least 5 words",
	"createPost.message.lengthTitle.characters": "The title must be at least 5 characters long.",
	"createPost.message.photoMaxium": "只允許上傳大小 <= 10 MB 的圖片",
	"createPost.message.photoSize": "必須填寫描述",
	"createPost.message.requiredDescription": "必須填寫標題",
	"createPost.message.requiredTitle": "描述必須至少 10 個字",
	"createPost.message.suggestLoading": "We are suggesting relevant communities for your post",
	"createPost.message.suggestResult": "You can post now! We will continue to find relevant communities right after that",
	"createPost.now": "Post now",
	"createPost.photos": "視頻",
	"createPost.popup.description": "Description",
	"createPost.popup.guideSelectMonthTopics": "Choose topics about your baby's birth month",
	"createPost.popup.guideSelectTopics": "Choose topics, where to post your articles",
	"createPost.popup.primary": "Tap to select/ unselect topics",
	"createPost.popup.selectMonthTopicBtn": "Select",
	"createPost.popup.specialCharErr": "The title you entered is invalid. Titles must contain letters.\n",
	"createPost.popup.submit": "Post",
	"createPost.popup.success": "New Post Created",
	"createPost.popup.warning": "Select a community to see your following topics",
	"createPost.popup.warningImage": "Maximum 20 images allow, please remove some item below",
	"createPost.popup.wordCount": "{count}/{max} words",
	"createPost.post.askDoctor.description": "Describe symptoms",
	"createPost.post.askDoctor.title": "Symptom name",
	"createPost.post.description": "Post description",
	"createPost.post.title": "Post title",
	"createPost.postAnonymous": "Post Anonymously",
	"createPost.title": "Title",
	"createPost.urlText": "Text",
	"createPost.video": "社群與主題",
	"createPost.videoOrLink": "向我們的專家諮詢",
	"dueDatePage.IUI": "人工授精（IUI）",
	"dueDatePage.calculationMethod": "計算方法",
	"dueDatePage.conceptionDate": "受孕日期",
	"dueDatePage.date_of_IUI_procedure": "打破卵針日期",
	"dueDatePage.date_of_ultrasound": "超音波檢查日期",
	"dueDatePage.daysText": "{number} 日",
	"dueDatePage.ivf": "試管嬰兒（IVF，體外受精）",
	"dueDatePage.ivf.transferDate": "植入日",
	"dueDatePage.ivf.transferDateRadio": "第 {number} 日胚胎植入",
	"dueDatePage.lastPeriod": "最後一次月經",
	"dueDatePage.lastPeriod.calculate": "計算",
	"dueDatePage.lastPeriod.lastPeriodLabel": "最後一次月經的第一天",
	"dueDatePage.lastPeriod.periodLengthLabel": "月經週期",
	"dueDatePage.ultrasound": "Ultrasound",
	"dueDatePage.ultrasound.tooltip": "Mean sac Diameter (MSD) is less accurate than Crown-Rump Length (CRL) for dating a pregnancy. It is only used in very early pregnancy, between 4 and 6 weeks.",
	"dueDatePage.validation.crl": "The MSD value is invalid. Please enter the CRL metric to continue.",
	"dueDatePage.validation.one_is_required": "請至少輸入一項資訊",
	"dueDatePage.validation.record_not_valid": "Your recorded isn't valid!",
	"editor.addSocialLink.addLink": "Add",
	"editor.addSocialLink.warningDomain": "添加",
	"expert.content.description": "個人檔案",
	"expert.content.experiences": "Experiences",
	"footer.signUp": "馬上註冊",
	"gender.boy": "男生",
	"gender.female": "女性",
	"gender.girl": "女生",
	"gender.male": "男性",
	"healthToolPNModal.back": "Back",
	"healthToolPNModal.findMore.chooseFav": "Choose from your favorite topics\n",
	"healthToolPNModal.finish": "完成",
	"healthToolPNModal.heading": "Nhận bản tin miễn phí mỗi tuần?",
	"healthToolPNModal.mainForm.requireName": "Please enter your name",
	"healthToolPNModal.mainForm.tailorTopicsHeading": "These topics are tailored to your result",
	"healthToolPNModal.next": "下一劑",
	"healthToolPNModal.register": "Register",
	"healthToolPNModal.yourPre": "Your preferences",
	"healthTools.dueDateCalculator": "預產期計算機",
	"healthTools.ovulationCalculator": "排卵期計算機",
	"healthtool.placeholder.age": "您的年齡",
	"home.calcWithApp": "Calculate on Hello Bacsi app",
	"home.menu.category.view": "查看類別：{category}",
	"home.navigator.app": "App",
	"home.navigator.downloadApp": "Download App",
	"home.navigator.menu.care.homeButton": "Booking Home",
	"home.navigator.menu.care.noDatas.cta": "Book a Doctor",
	"home.navigator.menu.care.noDatas.description": "HelloCare helps patients to find the right medical doctors and service treatment for their needs, in their vicinity.",
	"home.navigator.menu.care.noDatas.title": "Make an appointment with doctors easily",
	"home.navigator.menu.category.noDatas.cta": "Discover now",
	"home.navigator.menu.category.noDatas.description": "Hello Doctor wants to be your most trusted ally to make more informed decisions and to live healthier and happier lives.",
	"home.navigator.menu.category.noDatas.title": "Welcome to Hello Doctor",
	"home.navigator.menu.healthTools.noDatas.cta": "Discover more",
	"home.navigator.menu.healthTools.noDatas.description": "These easy-to-use health assessment tools will help you gauge vital parts of your overall health and wellness.",
	"home.navigator.menu.healthTools.noDatas.title": "Health Tools",
	"home.navigator.menu.lastestVideos": "最新短片",
	"home.navigator.menu.podcasts": "播客",
	"home.navigator.menu.shorts": "短片",
	"home.navigator.menu.spotlightEcom": "Categories",
	"home.navigator.menu.spotlightHospitals": "Popular Hospitals",
	"home.navigator.menu.spotlightTools": "編輯精選",
	"home.navigator.menu.spotlights": "所有主題",
	"home.navigator.menu.spotlights.seeAll": "看更多主題",
	"home.navigator.menu.together.noPosts.cta": "Join Our Communities",
	"home.navigator.menu.together.noPosts.description": "Community is a safe space where you can connect with other members, comment on topics you care about, and receive trusted advice from medical experts on the health issues that matter most.",
	"home.navigator.menu.together.noPosts.title": "Welcome to Community",
	"home.navigator.menu.trendingPosts": "Highlight Posts",
	"home.navigator.menu.trendingPosts.seeMore": "看更多",
	"home.navigator.menu.videos": "视频们",
	"home.navigator.menuItem.allCategories": "看所有類別",
	"home.navigator.menuItem.allCommunities": "See all communities",
	"home.navigator.menuItem.allCommunitiesheadingTitle": "Find your communities",
	"home.navigator.menuItem.allHealthTools": "看所有健康小工具",
	"home.navigator.menuItem.allSpecialties": "All specialties",
	"home.navigator.menuItem.allSpotlight": "看更多主題",
	"home.navigator.menuItem.allVideos": "See All Videos",
	"home.navigator.menuItem.discover": "探索",
	"home.navigator.menuItem.healthCategories": "更多類別",
	"home.navigator.menuItem.healthTools": "健康小工具",
	"home.navigator.menuItem.healthToolsList": "健康小工具",
	"home.navigator.menuItem.helloCare": "搜尋皮膚科門診",
	"home.navigator.menuItem.helloEcom": "eShop",
	"home.navigator.menuItem.helloTogether": "社群",
	"home.navigator.menuItem.language": "Language",
	"home.navigator.menuItem.new": "new",
	"home.navigator.menuItem.specialties": "Specialties",
	"home.navigator.menuItem.spotlights": "所有主題",
	"home.navigator.menuItem.video": "Video",
	"home.navigator.menuItem.videoCategories": "Video Categories",
	"home.search": "搜尋{site}",
	"home.seeAll": "看全部",
	"home.seeAllCategories": "看更多",
	"home.seeExpert": "查看完整專家資料",
	"home.seeHospital": "查看完整專家資料",
	"home.seeMore": "看更多",
	"home.seeMoreExperts": "看更多醫學專家",
	"hospital.content.description": "Hospital Details",
	"inputComment.replyTo": "Reply to {name}",
	insert: insert,
	"label.latestPost": "Latest Post",
	"label.pinnedPost": "Pinned Post",
	"lead.empty.cancel": "取消",
	"lead.empty.submitAgain": "重新提交",
	"lead.empty.title": "哎呀，您的資訊似乎是空的，您想要重新提交資訊嗎？",
	"leadgen.message.error.name_required": "Please enter your name",
	"leadgen.message.error.phone_invalid": "Please enter a valid phone number",
	loading: loading,
	"login.booking": "預約醫生",
	"logout.popup.ask.mb": "Logout of Marry Baby",
	"logout.popup.ask1": "你要登出 Hello 醫師嗎？",
	"logout.popup.ask2": "確認登出嗎？",
	"logout.popup.button.cancel": "取消",
	"logout.popup.button.logout": "登出",
	"menu.care.searchBySpecialties": "Search by specialty",
	"morePopover.report": "Report",
	"morePopover.report.description": "Help us understand what’s happening with this post. How would you describe it?",
	"morePopover.report.falseNews": "False news",
	"morePopover.report.offensive": "Offensive",
	"morePopover.report.other": "Other",
	"morePopover.report.prohibited": "Prohibited content",
	"morePopover.report.scam": "Misleading or scam",
	"morePopover.report.sex": "Sexually inappropriate",
	"morePopover.report.spam": "Spam",
	"morePopover.report.title": "Report this post",
	"morePopover.report.violence": "Violence",
	"morePopover.reportSubmit.description": "We won’t tell them who reported it. Please check these details:",
	"morePopover.reportSubmit.title": "Submit report?",
	"morePopover.savePost": "Save post",
	"morePopover.share": "Share",
	"morePopover.shareOn": "Share on",
	"morePopover.turnOffNotifications": "Turn off notifications",
	"morePopover.turnOnNotifications": "Turn on notifications",
	"morePopover.unsavePost": "Remove Saved post",
	"navigation.loginJoin": "登入",
	"navigation.search.input.placeholder": "搜尋",
	"navigation.signUp": "Sign up",
	"newsletter.error.minCotennt": "Please select at least 1 topic to continue this action",
	"newsletter.error.minTitle": "Minimum 1 topics reached",
	"newsletter.topic.title": "What health topics are you interested in?",
	"newsletter.welcome.description": "What name would you prefer to go by?",
	"notification.comment.blocked.message": "This comment contains banned words or phrases and won’t be published",
	"notification.comment.blocked.title": "Blocked comment",
	"notification.comment.premod": "這段留言需要經過審查",
	"notification.comment.rejected": "留言包含了不當字眼",
	"notification.comment.reportFailed": "檢舉失敗！",
	"notification.comment.reportSuccess": "成功檢舉一則留言",
	"notification.comment.somethingWrong": "好像出了什麼問題！",
	"notification.comment.suspect.message": "This comment contains suspected words or phrases and won’t be published",
	"notification.comment.suspect.title": "Pending comment",
	"notification.comment.systemWithheld": "這段留言需要經過審查",
	"notification.failure": "Something wrong. Try again later!",
	"notification.limitUrlDomain": "Cannot post link outside of Hello Health Group.",
	"notification.post.blocked.message": "This post contains banned words or phrases and won’t be published",
	"notification.post.blocked.title": "Blocked post",
	"notification.post.delete": "Post Deleted",
	"notification.post.suspect.message": "This post contains suspected words or phrases, and is placed for moderator review",
	"notification.post.suspect.title": "Pending post",
	"notification.success": "Success",
	"notification.suspend.message": "Your account has been suspended for violating our terms of service",
	"notification.urlWrongFormat": "Incorrect URL format",
	"onboarding.button.continue": "Continue",
	"onboarding.button.skip": "Skip",
	"onboarding.errorMessage.invalidEmail": "EMAIL地址錯誤",
	"onboarding.errorMessage.minLength": "Please fill at least {length} characters",
	"onboarding.errorMessage.passNotMatch": "密碼錯誤",
	"onboarding.errorMessage.passWithPattern": "Password must include upper and lowercase letters",
	"onboarding.errorMessage.requiredConfirmPassword": "Please fill your confirm password",
	"onboarding.errorMessage.requiredEmail": "Please fill your email",
	"onboarding.errorMessage.requiredName": "請輸入名字",
	"onboarding.errorMessage.requiredPassword": "Please fill your password",
	"onboarding.formEmail.description": "Continue with your email to continue with {site} communities",
	"onboarding.formEmail.genderFemale": "男性",
	"onboarding.formEmail.genderMale": "女性",
	"onboarding.formEmail.heading": "Let us get to know you better.",
	"onboarding.formEmail.yourBirthday": "您的生日",
	"onboarding.formEmail.yourEmail": "Your email",
	"onboarding.formEmail.yourName": "您的名字",
	"onboarding.label.fullName": "Full name",
	"onboarding.otpForm.description": "We have sent a One-Time Password (OTP) to your phone number {phone}",
	"onboarding.otpForm.descriptionEmail": "We have sent a One-Time Password (OTP) to your email {email}",
	"onboarding.otpForm.error": "請輸入正確的電話號碼",
	"onboarding.otpForm.heading": "Enter Your OTP",
	"onboarding.otpForm.notReceiveOTP": "Didn’t receive an OTP code?",
	"onboarding.otpForm.resendCode": "重新发送代码",
	"onboarding.otpForm.resendCodeWithSeconds": "Resend Code {seconds}s",
	"onboarding.otpWhatsapps.description": "我們已經將一次性密碼（OTP）發送到您的WhatsApp號碼{phone}",
	"onboarding.otpWhatsapps.heading": "WhatsApp 驗證",
	"onboarding.similac.address.error": "Your address is required",
	"onboarding.similac.input.address": "Your address",
	"onboarding.similac.input.city": "Please select your city/province",
	"onboarding.similac.input.district": "Please select your district/town",
	"onboarding.similac.input.no": "Please enter your street name, building, house no.",
	"onboarding.similac.input.phone": "Your phone number",
	"onboarding.similac.input.ward": "Please select your ward/village",
	"onboarding.updatePassword.confirmPassword": "Confirm Password",
	"onboarding.updatePassword.description": "Make sure it's a 8 characters or more",
	"onboarding.updatePassword.heading": "Almost there! You’ll need a password",
	"onboarding.updatePassword.password": "Password",
	"onboarding.updatePasswordResult.description": "You can now login to your Hellobacsi account with the new password.",
	"onboarding.updatePasswordResult.heading": "Password setup successful",
	"onboarding.updatePhone.description": "We will send a One-Time Password (OTP) to your phone number",
	"onboarding.updatePhone.error": "請輸入正確的電話號碼",
	"onboarding.updatePhone.heading": "Your phone number",
	"onboarding.updateWhatsapp.description": "Whatsapp 將需要驗證您的手機號碼。",
	"onboarding.updateWhatsapp.submitLabel": "繼續使用 WhatsApp",
	"onboarding.welcomeScreen.content": "An open and welcoming environment where you can share, connect, and exchange support with other members to seek healthier and happier lives.",
	"onboarding.welcomeScreen.heading": "Welcome to Hello Bacsi Community",
	orCopyLink: orCopyLink,
	"ovulationPage.avoidPregnancy": "避孕",
	"ovulationPage.conceive": "計畫懷孕",
	"ovulationPage.cycleLength": "月經週期",
	"ovulationPage.dayUnit": "天",
	"ovulationPage.objectives": "你的目標",
	"ovulationPage.periodDuration": "月經持續時間",
	"ovulationPage.trackPeriod": "追蹤月經週期",
	"placeholder.enterTitleHere": "Enter title here",
	"placeholder.enterUrlHere": "Enter URL here",
	"placeholder.enterUrlTextHere": "Enter URL Text here",
	"placeholder.newCmt": "Write a comment",
	"placeholder.newPost": "Start a new post",
	"pnBanner.both": "Both",
	"pnBanner.both.desc": "Welcome to the adventure of parenthood! Choose a tool that suit you.",
	"pnBanner.both.heading": "Experience our tools for parent!",
	"pnBanner.caclNow": "Calculate now",
	"pnBanner.checkNow": "Check now!",
	"pnBanner.dueDateTool.desc": "Plan ahead for the big day with a stress-free experience!",
	"pnBanner.dueDateTool.heading": "Try our Due Date Calculator",
	"pnBanner.hpv.desc": "Your response helps us craft recommendations specific to your family's needs.",
	"pnBanner.hpv.heading": "Keep your girl safe from HPV virus!",
	"pnBanner.parenting.desc": "Your response helps us craft recommendations specific to your family's needs. ",
	"pnBanner.parenting.heading": "What is the age range of your kids?",
	"pnBanner.pn.btnLabel": "Premium Newsletter",
	"pnBanner.pregnancy.desc": "Input this to ensure our recommendations suits your exciting new journey.",
	"pnBanner.pregnancy.heading": "Are you navigating the world of pregnancy?",
	"pnBanner.submit": "Submit",
	"pnBanner.teenager": "Teenager",
	"pnBanner.teenager.heading": "What is the gender of your kids?",
	"pnBanner.toddlers": "Toddlers",
	"pnBanner.vaccination.desc": "Keep your little one protected with customized vaccination schedules!",
	"pnBanner.vaccination.heading": "Try our Baby Vaccine Scheduler",
	"pnBanner.vaccine.btnLabel": "Baby Vaccine Scheduler",
	"pnModal.disclaimer": "Your first email digest is on its way. Get excited to dive into content that’s tailored specifically for you!",
	"pnTopicSection.maxSelectError.desc": "Remove at least 1 selected topic to continue this action",
	"pnTopicSection.maxSelectError.detail": "Choose maximum {max} topics ({maxTopic})",
	"pnTopicSection.maxSelectError.title": "Maximum {maxSelect} topics reached",
	"pnTopicSection.notFound": "Nothing found",
	"pnTopicSection.plsEnterFavTopics": "Please enter your favorite topics",
	"pnTopicSection.ppAlsoInterested": "People are also interested",
	"pnTopicSection.recentView": "Recently viewed",
	"pnTopicSection.trending": "Trending",
	"popup.allTopics": "All Topics",
	"popup.createPost.confirmCloseDescription": "If you discard now, you’ll lose this post",
	"popup.createPost.confirmCloseTitle": "Are you sure?",
	"popup.deleteComment.description": "Delete your comment cannot be undone",
	"popup.deleteComment.title": "Delete comment?",
	"popup.deletePost.accept": "Delete",
	"popup.deletePost.cancel": "Cancel",
	"popup.deletePost.description": "Delete your post cannot be undone",
	"popup.deletePost.title": "Delete post?",
	"popup.discardPost": "Discard post",
	"popup.discardPostEdit": "Discard changes",
	"popup.editPost": "Edit post",
	"popup.keepEditing": "Keep editing",
	"popup.startANewPost": "Start a new post",
	"post.commentCount": "{count} comments",
	"post.likesCount": "{count} likes",
	"post.remove.failed": "刪除失敗",
	"post.remove.success": "已刪除已儲存的帖子",
	"post.save.failed": "儲存帖子失敗",
	"post.save.success": "帖子已儲存",
	"post.seeMore": "See more",
	"post.shareCount": "{count} shares",
	"pregnancy.week": "週",
	"pregnancyTool.description": "嬰兒體型大約與<fruitName>一樣大",
	"pregnancyTool.title": "懷孕第幾周",
	"pregnancyTool.weightSuggested": "懷孕建議體重",
	"pregnancyWeightGain.havingTwins": "妳懷的是雙胞胎嗎？",
	"pregnancyWeightGain.heading": "懷孕體重計算器：懷孕體重控制、計算合理增重範圍",
	"pregnancyWeightGain.heightInput": "妳的身高：",
	"pregnancyWeightGain.weekInput": "目前懷孕週數：",
	"pregnancyWeightGain.weightBeforeInput": "懷孕前的體重：",
	"pregnancyWeightGain.weightInput": "目前體重：",
	"pregnancyWeightGain.weightInput.desc": "（公斤）",
	"pregnancyWeightGain.weightInput.error": "請輸入合理的體重",
	"previewPhotos.title": "{name}'s Post",
	"profilePanel.anserwing.viewFull": "View full answers",
	"profilePanel.awards": "Awards & Accreditations",
	"profilePanel.createPost": "Create post",
	"profilePanel.education": "Education",
	"profilePanel.emptyCareMess.content": "It looks like there are currently no questions for the doctor at this time. Thank you for being a part of our community.",
	"profilePanel.emptyPostMess.content": "{name} has not been engaged in any activities lately.",
	"profilePanel.experience": "Experiences",
	"profilePanel.joined": "Joined",
	"profilePanel.modal.heading": "Profile",
	"profilePanel.publishcation": "Publications",
	"profilePanel.publishedArticles": "Pulished article on Hello Bacsi",
	"profilePanel.question": "Question",
	"profilePanel.questionNotClear": "Question isn't clear",
	"profilePanel.skipQuestion.content": "We will remove this question from your list",
	"profilePanel.skipQuestion.heading": "Skip this question",
	"profilePanel.socialLinks": "Social Links",
	"profilePanel.tabs.care": "Care",
	"profilePanel.tabs.expertAnswer": "Expert Answering",
	"profilePanel.tabs.highlight": "Credentials & Highlights",
	"profilePanel.tabs.posts": "Posts",
	"profilePanel.tabs.relevantArticles": "Relevant Articles",
	"pwg.placeholder.height": "身高（公分）",
	"pwg.placeholder.weight": "體重（公斤）",
	"pwgForm.week": "週",
	"sensitiveMask.blur": "模糊圖片",
	"sensitiveMask.contentWarningDescription": "警告：以下圖片可能會令某些人感到不適，建議您自行斟酌觀看。",
	"sensitiveMask.contentWarningDescription.community": "Warning: The image may be disturbing.",
	"sensitiveMask.contentWarningMessage": "警告：以下圖片可能會令人感到不適。",
	"sensitiveMask.unblur": "顯示圖片",
	"share.by": "透過分享",
	"share.copyLink": "或複製連結",
	"share.letsJoinCommunity": "Let's join {name} community!",
	"share.letsJoinTopic": "Let's join {name} topic!",
	"share.linkCopied": "Link Copied",
	"share.linkShared": "Link Shared Successfully",
	"share.title": "分享",
	"shareContainer.title": "分享結果",
	"similac.thankYou.done": "Done",
	"ssov2.abTestingFlowB.description": "Sign up or log in with your email or social media account.",
	"ssov2.button.cancel": "Cancel",
	"ssov2.button.continue": "Continue",
	"ssov2.button.continueGoogle": "Continue with Google",
	"ssov2.button.continueSMS": "Continue with SMS",
	"ssov2.button.continueWhatsApp": "Continue with WhatsApp",
	"ssov2.button.continueZalo": "Continue with Zalo",
	"ssov2.button.exitNow": "I want to exit now",
	"ssov2.button.otp.sms": "Send OTP Code via SMS",
	"ssov2.button.otp.whatsapp": "Send OTP Code via WhatsApp",
	"ssov2.button.otp.zalo": "Send OTP Code via Zalo",
	"ssov2.button.save": "Save",
	"ssov2.button.setupLater": "Setup later",
	"ssov2.collectInfo.why": "Why We Need Your Information?",
	"ssov2.email.alreadyUsed": "Email này đã được sử dụng, vui lòng chọn Email khác.",
	"ssov2.email.button": "Verify Your Email",
	"ssov2.email.description": "Use your email to continue login or register",
	"ssov2.email.title": "Continue with email",
	"ssov2.error.api": "API error",
	"ssov2.error.api.000": "Some Things Went Wrong",
	"ssov2.error.api.001": "The email must be a valid email address.",
	"ssov2.error.api.002": "The email field is required.",
	"ssov2.error.api.003": "This member is not exist yet",
	"ssov2.error.api.004": "The email may not be greater than 255 characters.",
	"ssov2.error.api.005": "The phone number field is required.",
	"ssov2.error.api.006": "The phone number must be at least 9 characters.",
	"ssov2.error.api.007": "This phone number is already linked to your profile",
	"ssov2.error.api.008": "The otp code field is required.",
	"ssov2.error.api.009": "User don't update",
	"ssov2.error.api.010": "Verify OTP failed",
	"ssov2.error.api.011": "The name must be a string.",
	"ssov2.error.api.012": "The name may not be greater than 100 characters.",
	"ssov2.error.api.013": "The username must be a string.",
	"ssov2.error.api.014": "The username has already been taken.",
	"ssov2.error.api.015": "The username may not be greater than 20 characters.",
	"ssov2.error.api.016": "The birthday does not match the format Y-m-d.",
	"ssov2.error.api.017": "The avatar field is required.",
	"ssov2.error.api.018": "The avatar must be an image.",
	"ssov2.error.api.019": "The avatar must be a file of type: jpeg, jpg, png, gif.",
	"ssov2.error.api.020": "The avatar may not be greater than 10240 kilobytes.",
	"ssov2.error.api.021": "The confirm-password field is required.",
	"ssov2.error.api.022": "The confirm-password must be at least 8 characters.",
	"ssov2.error.api.023": "The confirm-password format is invalid.",
	"ssov2.error.api.024": "The confirm-password may not be greater than 50 characters.",
	"ssov2.error.api.025": "The new-password field is required.",
	"ssov2.error.api.026": "The new-password must be at least 8 characters.",
	"ssov2.error.api.027": "The new-password format is invalid.",
	"ssov2.error.api.028": "The new-password may not be greater than 50 characters.",
	"ssov2.error.api.029": "Your password doesn't match. Please try again.",
	"ssov2.error.api.030": "Your new password must be different from the current one",
	"ssov2.error.api.031": "The new password field is required.",
	"ssov2.error.api.032": "The confirm new password field is required.",
	"ssov2.error.api.033": "The new password and confirm new password must match.",
	"ssov2.error.api.034": "The confirm new password must be at least 8 characters.",
	"ssov2.error.api.035": "The new password must be at least 8 characters.",
	"ssov2.error.api.036": "The confirm new password may not be greater than 50 characters.",
	"ssov2.error.api.037": "The new password may not be greater than 50 characters.",
	"ssov2.error.api.038": "The current password is wrong!",
	"ssov2.error.api.039": "The password field is required.",
	"ssov2.error.api.040": "Token Signature could not be verified.",
	"ssov2.error.api.041": "Token has expired",
	"ssov2.error.api.042": "The refresh token field is required.",
	"ssov2.error.api.043": "The area code field is required.",
	"ssov2.error.api.044": "The email has already been taken.",
	"ssov2.error.api.045": "Verify Email OTP Code Fail",
	"ssov2.error.api.046": "The code field is required.",
	"ssov2.error.api.047": "The phone number has already been taken.",
	"ssov2.error.api.048": "The Phone is not match phone number that you registered",
	"ssov2.error.api.049": "User was exist",
	"ssov2.error.api.050": "The website id field is required.",
	"ssov2.error.api.051": "The name field is required.",
	"ssov2.error.api.052": "The birthday field is required.",
	"ssov2.error.api.053": "The gender field is required.",
	"ssov2.error.api.054": "The provider field is required.",
	"ssov2.error.api.055": "The token field is required.",
	"ssov2.error.api.056": "Code has been sent to your email",
	"ssov2.error.api.057": "The email does not exist.",
	"ssov2.error.api.058": "You are verifying a phone number that is not yours",
	"ssov2.error.api.059": "The selected phone number is invalid.",
	"ssov2.error.api.060": "Phone does not member",
	"ssov2.error.api.061": "This phone number is already linked to your profile",
	"ssov2.error.api.062": "Error ZNS with missing msg_id",
	"ssov2.error.api.063": "OTP verify missing",
	"ssov2.error.api.064": "The expire at must be a date after 5 mins.",
	"ssov2.error.api.065": "The selected code is invalid.",
	"ssov2.error.api.066": "Error when update ZNS tracking",
	"ssov2.error.api.067": "Sent Zalo OTP failed",
	"ssov2.error.api.068": "The expire at must be a date after 10 mins.",
	"ssov2.error.api.069": "The code must be at least 6 characters.",
	"ssov2.error.api.070": "The code may not be greater than 10 characters.",
	"ssov2.error.api.071": "You’ve reached the limit of 3 verification attempts in 1 hour. Please wait and try again later.",
	"ssov2.error.api.072": "You’ve reached the limit of 5 verification attempts today. Please try again tomorrow.",
	"ssov2.error.api.073": "The password must be at least 8 characters.",
	"ssov2.error.api.074": "The password format is invalid.",
	"ssov2.error.api.075": "The confirm-password format is invalid.",
	"ssov2.error.api.076": "The password must contain at least one number.",
	"ssov2.error.api.077": "The confirm-password must contain at least one number.",
	"ssov2.error.api.078": "The email was exist",
	"ssov2.error.api.079": "Too many messages",
	"ssov2.error.api.080": "The selected otp code is invalid",
	"ssov2.error.api.082": "The password must contain at least one uppercase and one lowercase letter.",
	"ssov2.error.api.083": "Sent Whatsapp OTP failed",
	"ssov2.error.facebookLogin": "Facebook login failed",
	"ssov2.error.googleLogin": "Error login with Google",
	"ssov2.first.country.code": "Country Code",
	"ssov2.first.description": "Continue with your phone number, email or your socials to log in or sign up.",
	"ssov2.first.noAccountOrPass": "You have no account or need to setup password, please continue register",
	"ssov2.first.search.country.all": "All Countries",
	"ssov2.first.search.country.placeholder": "Search country/region",
	"ssov2.first.search.country.selected": "Current selection",
	"ssov2.first.title.login": "Log In",
	"ssov2.first.title.signup": "Sign Up",
	"ssov2.orContinueWith": "Or continue with",
	"ssov2.otp.email.description": "Enter the 6-digit OTP sent to your email <b>{email}</b>. OTP code will expire in <b>10 mins</b>",
	"ssov2.otp.email.title": "Verify Email",
	"ssov2.otp.phone.description": "Enter the 6-digit OTP sent to the phone number <b>{phone}</b> via <b>{method}</b>. OTP code will expire in <b>10 mins</b>",
	"ssov2.otp.phone.title": "Verify Phone Number",
	"ssov2.otp.resendQuestion": "Didn’t receive the code?",
	"ssov2.otp.resendText": "Resend ({count}s)",
	"ssov2.otp.sendVia": "Send OTP Code via {method}",
	"ssov2.password.description": "Đăng nhập bằng mật khẩu của bạn.",
	"ssov2.password.forgotPassword": "Forgot Password?",
	"ssov2.password.reset": "Reset",
	"ssov2.password.signIn": "Sign In",
	"ssov2.password.title1": "Welcome back!",
	"ssov2.password.title2": "Enter your password",
	"ssov2.passwordForgotSetup.description": "Set up your login password and other details to complete the registration process.",
	"ssov2.passwordForgotSetup.field.password.atLeast8Chars": "At least 8 characters.",
	"ssov2.passwordForgotSetup.field.password.atLeastOneUpper": "At least one uppercase letter, one lowercase letter, and one number.",
	"ssov2.passwordForgotSetup.field.password.label": "Password",
	"ssov2.passwordForgotSetup.field.password.placeholder": "Input your password",
	"ssov2.passwordForgotSetup.field.passwordConfirm.label": "Confirm Password",
	"ssov2.passwordForgotSetup.field.passwordConfirm.placeholder": "Confirm Password",
	"ssov2.passwordForgotSetup.title": "Setup your password",
	"ssov2.phone.alreadyUsed": "Phone number is already used, please use another phone number",
	"ssov2.phoneVerify.description": "Please provide additional information to complete the account registration process.",
	"ssov2.phoneVerify.title": "Verify Phone Number",
	"ssov2.policyText": "By signing up, I confirm that I have read, understand and agree to the {privacy} and the {terms} of Hello Health Group. I agree for Hello Health Group to collect, store, use, disclose, and process my information in accordance with Hello Health Group’s Privacy Policy. Furthermore, I agree for Hello Health Group to use my information to send me promotional information (including by direct mail, email, telephone, and text message) or otherwise contact me about products, services, programs or other topics that Hello Health Group think may interest me; and Hello Health Group can share my information to its partners and clients in order for them to provide more helpful services and promotional information.",
	"ssov2.policyText.community": "By signing up, I confirm that I have read, understand and agree to the {privacy} and the {terms} of Hello Health Group. I agree to join the community of HelloDoctor, and I agree for Hello Health Group to collect, store, use, disclose, and process my information in accordance with Hello Health Group’s Privacy Policy. Furthermore, I agree for Hello Health Group to use my information to send me promotional information (including by direct mail, email, telephone, and text message) or otherwise contact me about products, services, programs or other topics that Hello Health Group think may interest me; and Hello Health Group can share my information to its partners and clients in order for them to provide more helpful services and promotional information.",
	"ssov2.policyText.privacy": "Privacy Policy",
	"ssov2.policyText.terms": "Terms of Service",
	"ssov2.popup.close.description": "You’re just a step away from completing your account setup. Do you really want to leave?",
	"ssov2.popup.close.title": "Are you sure you want to exit?",
	"ssov2.resetPassword.description": "Please provide the phone number you used to create your account.",
	"ssov2.resetPassword.title": "Reset password",
	"ssov2.setup.button.createAccount": "Create new account",
	"ssov2.setup.button.veriyPhone": "Verify Phone Number",
	"ssov2.setup.description": "Please provide additional information to complete the account registration process.",
	"ssov2.setup.field.dob.label": "Birthday",
	"ssov2.setup.field.dob.placeholder": "Enter your birthday",
	"ssov2.setup.field.email.label": "Email",
	"ssov2.setup.field.gender.female": "Female",
	"ssov2.setup.field.gender.label": "Gender",
	"ssov2.setup.field.gender.male": "Male",
	"ssov2.setup.field.name.label": "Name",
	"ssov2.setup.field.name.placeholder": "Enter your name",
	"ssov2.setup.field.otp.label": "Receive OTP Via",
	"ssov2.setup.field.phone.label": "Phone number",
	"ssov2.setup.title": "Almost done!",
	"ssov2.updateEmail.button": "Verify Your Email",
	"ssov2.updateEmail.description": "Please update and verify your email to continue using our services.",
	"ssov2.updateEmail.title": "Update Your Email",
	"ssov2.useOtherMethod.email": "This account has not enabled login with an email. Please choose another login method.",
	"ssov2.useOtherMethod.phone": "This account has not enabled login with a phone number. Please choose another login method.",
	"ssov2.validate.confirmPassword.match": "Passwords must match",
	"ssov2.validate.confirmPassword.required": "Confirm password is required",
	"ssov2.validate.dob.required": "Date of birth is required",
	"ssov2.validate.email.invalid": "Invalid email",
	"ssov2.validate.email.required": "Email is required",
	"ssov2.validate.gender.oneOf": "Gender must be male or female",
	"ssov2.validate.gender.required": "Gender is required",
	"ssov2.validate.name.required": "Name is required",
	"ssov2.validate.otp.required": "OTP method is required",
	"ssov2.validate.password.required": "Password is required",
	"ssov2.validate.phone.required": "Phone number is required",
	submit: submit,
	"switchBtn.no": "否",
	"switchBtn.yes": "是",
	"tab.about": "About",
	"tab.discussion": "Discussions",
	"tab.topic": "Topics",
	"tagTopic.moreTopics": "{number} more topics",
	"targetHearRate.heading": "目標心率計算機：估算最大心率、靜止心率",
	"targetHeartRate.aerobicZone.note": "中高運動量（中強度運動，一週3-5天）",
	"targetHeartRate.aerobicZone.title": "中高運動量",
	"targetHeartRate.ageInput": "你的出生日期？",
	"targetHeartRate.ageInput.desc": "（年）",
	"targetHeartRate.ageInput.error": "請輸入你的真實年齡",
	"targetHeartRate.heartRateInput": "你的靜止心率為多少？",
	"targetHeartRate.heartRateInput.desc": "（bpm）",
	"targetHeartRate.heartRateInput.error": "請輸入正確的靜止心率範圍",
	"targetHeartRate.lowIntensity.note": "低運動量（很少或沒有運動）",
	"targetHeartRate.lowIntensity.title": "低運動量",
	"targetHeartRate.maximumIntensity.note": "極高度運動量（超高強度運動，訓練量有如運動員）",
	"targetHeartRate.maximumIntensity.title": "極高度運動量",
	"targetHeartRate.moderateIntensity.note": "中運動量（中低強度運動，每週1-3天）",
	"targetHeartRate.moderateIntensity.title": "中運動量",
	"targetHeartRate.optional": "（選填）",
	"targetHeartRate.selectActive": "你的日常活動程度為何？",
	"targetHeartRate.vigorousIntensity.note": "高運動量（高強度運動，一週6-7天）",
	"targetHeartRate.vigorousIntensity.title": "高運動量",
	"tool.askChecking": "代別人查詢",
	"tool.selectPerson": "你想檢測的對象？",
	"tool.selectPerson.other": "其他人",
	"tool.selectPerson.yourSelf": "自己",
	"toolPage.toolReviewer": "{expert_name}於{date}審閱",
	"tools.checkYourKidsInput.label": "您在檢視自己孩子的情況嗎？",
	"tools.checkYrs": "你正在為自己檢查嗎？",
	"tools.heading.on": "on",
	"tools.heartRateRangeErr": "請輸入 {min} - {max} bpm 的數值",
	"tools.inputPlaceholder": "例: {content}",
	"tools.requiredErrorMess.age": "請輸入合理的數值",
	"tools.requiredErrorMess.gender": "請輸入性別",
	"tools.selectBabyGender": "請問您孩子的性別是？",
	"tools.selectGender": "你的性別",
	"tools.yearsOld": "歲",
	"updatePost.popup.success": "The post has been updated successfully.",
	"userProfile.nav.card.eCom": "eShop",
	"userProfile.nav.card.ecom.DeliveryAddress": "Manage addresses",
	"userProfile.nav.card.ecom.manageOrders": "Manage orders",
	"userProfile.nav.card.ecom.voucher": "Voucher",
	"userProfile.nav.card.myBooking": "我的預約",
	"userProfile.nav.card.myCommunity": "我的群組",
	"userProfile.nav.card.myFamily": "其他家人",
	"userProfile.nav.card.myHealth": "我的健康紀錄",
	"userProfile.nav.card.mySaved": "我的收藏",
	"userProfile.nav.header.count.comments": "留言",
	"userProfile.nav.header.count.posts": "貼文",
	"userProfile.nav.header.count.tools": "小工句",
	"userProfile.nav.header.points": "我的積分",
	"userProfile.nav.header.viewProfile": "檢視個人檔案",
	"userProfile.nav.menu.accountSettings": "帳戶設定",
	"userProfile.nav.menu.dataPrivacy": "資料隱私",
	"userProfile.nav.menu.disableAccount": "刪除帳戶",
	"userProfile.nav.menu.help": "常見問題",
	"userProfile.nav.menu.logout": "登出",
	"userProfile.nav.menu.password": "密碼",
	"userProfile.userRank.ambassador": "Ambassador",
	"userProfile.userRank.doctor": "醫師",
	"userProfile.userRank.expert": "專家",
	"userProfile.userRank.influencer": "名人",
	"userProfile.userRank.member": "會員",
	"validation.error.requiredAgeGroup": "Your child is not in the required age group",
	"validation.error.requiredField": "此為必填欄位",
	"verifyBotAnswer.confirmEndorse.accept": "Yes, endorse",
	"verifyBotAnswer.confirmEndorse.cancel": "No, cancel",
	"verifyBotAnswer.confirmEndorse.description": "Thank you for endorsing the answer",
	"verifyBotAnswer.confirmEndorse.heading": "Endorse this answer",
	"searchPage.result": "公開"
};

export { character, copied, copy, zhTranslations as default, insert, loading, orCopyLink, submit };
